<template>
    <div>
        <v-checkbox label="set with state" v-model="current_form.with_state" @click.stop="toggleCheckbox(current_form, true)"></v-checkbox>
        <v-checkbox label="set without state" v-model="current_form.without_state" @click.stop="toggleCheckbox(current_form, false)"></v-checkbox>
        <v-checkbox label="simple" v-model="current_form.simple" @click.stop="toggleSimple(current_form)"></v-checkbox>
        <v-checkbox label="uninitialized" v-model="current_form.uninitialized" @click.stop="toggleUninitialized(current_form)"></v-checkbox>
    </div>
</template>
<script>

export default {
    data() {
        return {
            current_form: {
                with_state: false,
                without_state: false,
                simple: false
            }   
        }
    },
    methods: {
        toggleCheckbox(current, useState){
            if(useState){
                console.log("with_state old", _.cloneDeep(current).with_state)
                let state = _.cloneDeep(current.checkbox_val)
                this.$set(current, 'with_state', !state)
                console.log("with_state new", current.with_state)
            } else {
                console.log("without_state old", _.cloneDeep(current).without_state)
                this.$set(current, 'without_state', !current.without_state)
                console.log("without_state new", current.without_state)
            }
        },
        toggleSimple(current){
            console.log("simple old", current.simple)
            current.simple = !current.simple
            console.log("simple new", current.simple)
        },
        toggleUninitialized(current){
            console.log("uninitialized old", current.uninitialized)
            if(current.uninitialized != undefined || current.uninitialized != null){
                this.$set(current, 'uninitialized', !current.uninitialized)
            } else {
                this.$set(current, 'uninitialized', true)
            }
            console.log("uninitialized new", current.uninitialized)
        }
    },
}
</script>